import { render, staticRenderFns } from "./ResultModel.vue?vue&type=template&id=ee803446&scoped=true&"
import script from "./ResultModel.vue?vue&type=script&lang=js&"
export * from "./ResultModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee803446",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/service/ResultModel.vue
// module id = null
// module chunks = 